import classNames from 'classnames';
import { forwardRef, KeyboardEvent } from 'react';
import * as FeatherIcons from 'react-feather';
import styles from './Icon.module.css';
import { IconProps } from './Icon.types';

const Icon = forwardRef<SVGSVGElement, IconProps & FeatherIcons.IconProps>(
  ({ iconName, title, id, disabled = false, onClick, className, tabIndex, onKeyDown, size, ...props }, ref) => {
    // include tabIndex = 0 if onClick exists but don't overwrite prop passed in
    const internalTabIndex = onClick && !disabled ? 0 : undefined;
    const handleKeyDown = (event: KeyboardEvent<SVGSVGElement>) => {
      if (onKeyDown) onKeyDown(event);
      if ((event.key === ' ' || event.key === 'Enter') && onClick) {
        event.preventDefault();
        onClick(event);
      }
    };
    const Component = FeatherIcons[iconName] as React.ForwardRefExoticComponent<
      FeatherIcons.IconProps & React.RefAttributes<SVGSVGElement>
    >;
    return (
      <Component
        ref={ref}
        aria-label={title ?? iconName}
        onKeyDown={handleKeyDown}
        tabIndex={tabIndex ?? internalTabIndex}
        id={id}
        onClick={onClick}
        role={onClick !== undefined ? 'button' : undefined}
        className={classNames({
          [styles.iconButton]: onClick !== undefined,
          [styles.disabled]: disabled,
          [styles.icon]: true,
          [className!]: className !== undefined,
        })}
        size={size || 24}
        {...props}
      />
    );
  },
);

Icon.displayName = 'Icon';

export default Icon;
